import { Link } from 'react-router-dom';
import { AREAS, SITE } from '../../lib/u99';
import { useLibrary, ELI_ELY_SLUG } from '../../lib/library';

export default function U99Footer() {
  const lib = useLibrary();
  const pubs = lib ? lib.documents.filter((d) => d.body_format === 'text').sort((a, b) => a.publication_order - b.publication_order) : [];
  return (
    <footer className="border-t border-white/[0.06] mt-24 pb-24 md:pb-10" data-testid="u99-footer">
      {pubs.length > 0 && (
        <div className="max-w-7xl mx-auto px-5 lg:px-10 pt-12" data-testid="u99-footer-publications">
          <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
            <p className="font-mono-precision text-[10px] uppercase tracking-[0.3em] text-slate-500">Standalone publications · free to read</p>
            <Link to="/u99/library" className="font-mono-precision text-[10px] uppercase tracking-[0.25em] text-amber-300 hover:text-amber-200" data-testid="u99-footer-library-link">Full library index →</Link>
          </div>
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2">
            {lib.books.map((b) => <li key={b.id}><Link to={`/u99/book/${b.slug}`} className="font-celestial text-sm text-slate-400 hover:text-amber-300 transition-colors" data-testid={`u99-footer-book-${b.slug}`}>{b.title}</Link></li>)}
            <li><Link to={`/u99/documents/${ELI_ELY_SLUG}`} className="font-celestial text-sm text-fuchsia-300/90 hover:text-fuchsia-200 transition-colors" data-testid="u99-footer-eli-ely">ELI &amp; ELY: THE SPLIT PART ONE</Link></li>
            {pubs.map((p) => <li key={p.id}><Link to={`/u99/documents/${p.slug}`} className="font-celestial text-sm text-slate-400 hover:text-amber-300 transition-colors" data-testid={`u99-footer-pub-${p.slug}`}>{p.title}</Link></li>)}
          </ul>
        </div>
      )}
      <div className="max-w-7xl mx-auto px-5 lg:px-10 pt-12 grid md:grid-cols-3 gap-10">
        <div>
          <p className="font-celestial text-sm tracking-[0.25em] text-slate-100">UNITED 99 <span className="text-amber-300">UNLEASHED</span></p>
          <p className="mt-3 text-sm text-slate-500 leading-relaxed max-w-xs">Readable pages first. Files as downloads. Every claim labelled for what it is. Everything free — no sign-up, no paywall.</p>
          <p className="mt-4 font-mono-precision text-[10px] tracking-[0.2em] text-slate-600">{SITE}</p>
        </div>
        <div>
          <p className="font-mono-precision text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">Areas</p>
          <ul className="space-y-2">
            {AREAS.map((a) => <li key={a.id}><Link to={a.to} className="text-sm text-slate-400 hover:text-amber-300 transition-colors" data-testid={`u99-footer-${a.id}`}>{a.label}</Link></li>)}
          </ul>
        </div>
        <div>
          <p className="font-mono-precision text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">Notice</p>
          <p className="text-sm text-slate-500 leading-relaxed">Psychology tools on this site are for reflection only. They do not diagnose, treat or replace professional care.</p>
          <p className="mt-6 font-celestial text-sm tracking-wide text-amber-100/80" data-testid="footer-copyright">© Kyle Hinton, {new Date().getFullYear()}. All rights reserved.</p>
          <p className="mt-3 font-mono-precision text-[10px] tracking-[0.2em] text-slate-600">A <Link to="/" className="hover:text-cyan-300">SIDETRACK AI STUDIOS</Link> PRODUCTION · <Link to="/admin" className="hover:text-slate-400" data-testid="u99-footer-vault">VAULT</Link></p>
        </div>
      </div>
    </footer>
  );
}
